export function Score({ value }) {
  if (value == null) {
    return (
      <span className="score score-lo" title="not yet scored">
        <span className="score-num">·</span>
        <span style={{ fontSize: 11 }}>UNSCORED</span>
      </span>
    );
  }
  const cls = value >= 85 ? 'score-hi' : value >= 70 ? 'score-mid' : 'score-lo';
  return (
    <span className={`score ${cls}`} title={`Fit score: ${value}/100`}>
      <span className="score-num">{value}</span>
      <span style={{ fontSize: 11 }}>FIT</span>
    </span>
  );
}
